import React from 'react';
import Breadcrumbs from '../../sections/Breadcrumbs';

const HowItWorks: React.FC = () => (
  <div className="max-w-4xl mx-auto py-12 px-4">
    <Breadcrumbs items={[
      { label: 'Home', href: '/' },
      { label: 'About', href: '/about' },
      { label: 'How It Works' }
    ]} />
    <h1 className="text-3xl font-bold mb-4">How It Works</h1>
    <p>This is a placeholder for the How It Works page.</p>
  </div>
);

export default HowItWorks; 